import { Call, Close, Email, MoreVert, RemoveRedEye, Search } from "@mui/icons-material";
import { Autocomplete, Avatar, Backdrop, Box, Button, Card, CardContent, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Drawer, FormControl, FormControlLabel, Grid, IconButton, InputLabel, Menu, MenuItem, Pagination, Rating, Select, Step, StepButton, Stepper, Switch, Table, TableBody, TableCell, TableRow, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";

export const ExistingCandidateList = ({ openExistingCandidateDrawer, handleCloseExistingCandidateDrawer, handleProcessCandidates, selectedCandidates,
    selectedExperience, experienceOptions, selectedSource, sourceOptions, candidates, filteredCandidates, currentCandidates, candidatesPerPage, currentPage, handlePageChange, setSelectedSource, setSelectedExperience, handleToggleCandidate, setSearchQuery, loading }) => {
    const [controller] = useMaterialUIController();
    //const { darkMode } = controller;

    return (
        <>

            <Backdrop open={loading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Drawer
                anchor="right"
                open={openExistingCandidateDrawer}
                onClose={handleCloseExistingCandidateDrawer}
                PaperProps={{
                    sx: { width: '80%', margin: '0px', padding: '12px', height: "100%", borderRadius: 0, boxShadow: 3 }
                }}
            >
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexDirection={{ xs: "column", sm: "row" }} gap={{ xs: 2, sm: 0 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={handleCloseExistingCandidateDrawer}>
                            <Close />
                        </IconButton>
                        <Typography variant="h5" fontWeight="bold" textAlign={{ xs: "center", sm: "left" }} fontSize={{ xs: "15px", sm: "25px" }}>Select Existing Candidate</Typography>

                    </Box>

                    <Box display="flex" alignItems="center" flexDirection={{ xs: "column", sm: "row" }}>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleProcessCandidates}
                            disabled={selectedCandidates.length === 0}
                            sx={{ color: "#fff" }}
                        >
                            Process ({selectedCandidates.length})
                        </Button>
                    </Box>
                </Box>
                <Divider sx={{ mb: 2 }} />

                {/* Filters & Search */}
                <Box display="flex" gap={2} mb={2} flexWrap="wrap">
                    {/* Experience Filter */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <InputLabel>Experience</InputLabel>
                        <FormControl sx={{ minWidth: 140 }}>
                            <Select
                                sx={{ height: "35px" }}
                                value={selectedExperience}
                                onChange={(e) => setSelectedExperience(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">All</MenuItem>
                                {experienceOptions.map(exp => (
                                    <MenuItem key={exp} value={exp}>{exp} Years</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    {/* Source Filter */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <InputLabel>Source</InputLabel>
                        <FormControl sx={{ minWidth: 140 }}>
                            <Select
                                sx={{ height: "35px" }}
                                value={selectedSource}
                                onChange={(e) => setSelectedSource(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">All</MenuItem>
                                {sourceOptions.map(source => (
                                    <MenuItem key={source} value={source}>{source}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    {/* Search Field */}
                    <Autocomplete
                        freeSolo
                        options={candidates.map(c => c.full_name)}
                        onInputChange={(event, value) => setSearchQuery(value)}
                        onChange={(event, value) => setSearchQuery(value || "")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search Candidate"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: <Search sx={{ mr: 1 }} />,
                                }}
                            />
                        )}
                        sx={{ flexGrow: 1, minWidth: 200 }}
                    />
                </Box>

                {/* Candidate Grid */}
                <Grid container spacing={2}>
                    {currentCandidates.length > 0 ? (
                        currentCandidates.map((candidate) => (
                            <Grid item xs={12} sm={6} md={4} key={candidate.id}>
                                <Box
                                    sx={{
                                        p: { xs: 1, sm: 2 },
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        gap: 1,
                                        boxShadow: 1,
                                        bgcolor: "white",
                                        position: "relative"
                                    }}
                                >
                                    {/* Checkbox in the top-right corner */}
                                    <Checkbox
                                        checked={selectedCandidates.includes(candidate.id)}
                                        onChange={() => handleToggleCandidate(candidate.id)}
                                        inputProps={{ 'aria-label': `Select ${candidate.full_name}` }}
                                        sx={{
                                            position: "absolute",
                                            top: 5,
                                            right: 5
                                        }}
                                    />

                                    {/* Avatar */}
                                    <Avatar sx={{ width: 56, height: 56, bgcolor: "#007BFF", color: "white", fontSize: { xs: 24, sm: 28 } }}>
                                        {candidate.full_name.charAt(0)}
                                    </Avatar>

                                    {/* Candidate Info */}
                                    <Typography variant="h6" sx={{ fontSize: { xs: "0.865rem", sm: "1rem" } }}>{candidate.full_name}</Typography>
                                    <Typography variant="body2" sx={{ fontSize: { xs: "0.865rem", sm: "0.8rem" } }}>{candidate.email}</Typography>
                                    <Typography variant="body2" sx={{ fontSize: { xs: "0.865rem", sm: "0.9rem" } }}>{candidate.experience} years experience</Typography>
                                    <Typography variant="body2" sx={{ fontSize: { xs: "0.865rem", sm: "0.9rem" } }}>Source: {candidate.source}</Typography>
                                    {candidate.cv && (
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            sx={{ mt: 1, textTransform: "none", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                                            onClick={() => window.open(candidate.cv, "_blank")}
                                        >
                                            <Typography variant="body2" fontSize='14px' color='ButtonText'>View CV</Typography>
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                        ))
                    ) : (
                        <Typography variant="body1" textAlign="center" width="100%" sx={{ mt: 2 }}>
                            No candidates found
                        </Typography>
                    )}
                </Grid>


                <MDBox display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={Math.ceil(filteredCandidates.length / candidatesPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                    />
                </MDBox>


            </Drawer>
        </>
    )
}

export const CandidateDetails = ({ openDrawer, handleCloseDrawer, selectedCandidate, handleMoveToNextStage, setCandidates, handleOpenScheduleDialog, setOpenDrawer, interviewList, employeeOptions, option }) => {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [expandedInterview, setExpandedInterview] = useState(null);
    const [interviewFeedback, setInterviewFeedback] = useState(null);

    const [interviewFeedbackState, setInterviewFeedbackState] = useState(null)
    const [jobOfferDialogOpen, setJobOfferDialogOpen] = useState(false);
    const [jobOfferError, setJobOfferError] = useState("");
    const [jobOfferPayload, setJobOfferPayload] = useState({
        expected_doj: moment(new Date()).format("YYYY-MM-DD"),
        ctc: "",
        active: true,
    });


    useEffect(() => {
        const feedBackCondition = interviewList?.interviews?.some((item1) =>
            interviewFeedbackState?.some((item2) => item1?.id === item2?.interview)
        );
    }, [interviewList, interviewFeedbackState, setInterviewFeedbackState]);

    const handleToggleFeedback = async (interviewId) => {
        setExpandedInterview((prev) => (prev === interviewId ? null : interviewId));
        var res = await ApiCalls.getFeedbacksList();

        if (res.success && res.code == 200) {
            setInterviewFeedbackState(res.data)
            let feedback = res.data.find((item) => {
                return item.interview === interviewId
            });
            setInterviewFeedback(feedback)
        } else {
        }
    };

    // if(selectedCandidate){
    const statusOptions = selectedCandidate && Object.entries(selectedCandidate?.candidate?.status_choices).map(([key, value]) => ({
        value: Number(key), // Convert key to number if needed
        label: value
    }));
    // }

    // const [formData, setFormData] = useState({
    //     status: 1,
    //     rating: 2,
    //     evaluated_exp: 3,
    //     feedback: "asdfg",
    //     org: 3,
    //     interview: 3,
    //     interviewer: 15
    // });

    // const handleChange = (field) => (event) => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         [field]: event.target.value
    //     }));
    // };

    // const handleAutocompleteChange = (field) => (_, newValue) => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         [field]: newValue ? newValue.value : null
    //     }));
    // };

    // const handleSubmit = async () => {
    //     console.log("Payload:", formData);
    //     const res = await ApiCalls.postCandidateFeedback(formData);
    //     console.log(res);
    // };

    const STAGE_TYPE_OPTIONS = [
        { value: 1, label: "New" },
        { value: 2, label: "Screening" },
        { value: 3, label: "System Test" },
        { value: 4, label: "Interview" },
        { value: 5, label: "Selected" },
        { value: 6, label: "Job Offered" },
        { value: 7, label: "Onboarded" },
        { value: 8, label: "Archived" },
      ];

    const currentStage = selectedCandidate?.current_stage;
    const currentFlow = selectedCandidate?.current_flow;
    let typeLabel = ''

    const nextStage = currentFlow?.flow_stages?.find(
        stage => stage.sequence === currentStage.sequence + 1
    );
    typeLabel = STAGE_TYPE_OPTIONS?.find(
        item => item?.value === currentFlow?.type
    )?.label;

    let nextStageTypeLabel = typeLabel;
    const isSelectedStage =
        Number(selectedCandidate?.current_flow?.type) === 5 &&
        Number(selectedCandidate?.candidate?.status) === 4;

    const handleOpenJobOfferDialog = () => {
        setJobOfferPayload({
            expected_doj: moment(new Date()).format("YYYY-MM-DD"),
            ctc:
                selectedCandidate?.job_ad?.min_ctc ||
                selectedCandidate?.job_advertisement?.min_ctc ||
                "",
            active: true,
        });
        setJobOfferError("");
        setJobOfferDialogOpen(true);
    };

    const handleCloseJobOfferDialog = () => {
        setJobOfferDialogOpen(false);
        setJobOfferError("");
    };

    const handleCreateJobOffer = async () => {
        if (!selectedCandidate?.candidate?.id || !selectedCandidate?.id) {
            setJobOfferError("Candidate and job opening details are required.");
            return;
        }

        if (!jobOfferPayload.expected_doj) {
            setJobOfferError("Expected DOJ is required.");
            return;
        }

        if (jobOfferPayload.ctc === "" || Number(jobOfferPayload.ctc) <= 0) {
            setJobOfferError("CTC must be greater than 0.");
            return;
        }

        const payload = {
            candidate: selectedCandidate.candidate.id,
            job_opening: selectedCandidate.id,
            expected_doj: jobOfferPayload.expected_doj,
            ctc: Number(jobOfferPayload.ctc),
            active: jobOfferPayload.active,
        };

        const res = await ApiCalls.postJobOffer(payload, false);
        if (res?.success && res?.code === 201) {
            setJobOfferDialogOpen(false);
            setJobOfferError("");
        }
    };

    return (
        <>
        <Drawer
            anchor="right"
            open={openDrawer}
            onClose={handleCloseDrawer}
            PaperProps={{
                sx: {
                    width: { xs: "100vw", sm: 520 },
                    maxWidth: "100vw",
                    p: 0,
                    height: "100%",
                    borderRadius: 0,
                    boxShadow: 3,
                    bgcolor: "#f8fafc",
                    margin: 0,
                    overflow: "hidden",
                }
            }}
        >
            <Box
                sx={{
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                    background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                    color: "white",
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    gap={1.5}
                >
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <MDTypography variant="h5" fontWeight="bold" sx={{ color: "White" }}>
                            Candidate Details
                        </MDTypography>
                        <MDTypography variant="body2" sx={{ color: "rgba(255,255,255,0.86)", mt: 0.5 }}>
                            Review the current stage, candidate profile, and interview progress without leaving the job opening view.
                        </MDTypography>
                    </Box>
                    <IconButton onClick={handleCloseDrawer} sx={{ color: "white" }}>
                        <Close />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{ p: { xs: 2, sm: 2.5 }, overflowY: "auto", height: "100%" }}>
            {/* Header */}
            {/* Candidate Details */}
            {selectedCandidate && (
                <Box display="flex" flexDirection="column" gap={2}>
                    <Box
                        display="flex"
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        flexDirection={{ xs: "column", sm: "row" }}
                        gap={2}
                        p={2}
                        sx={{
                            bgcolor: "white",
                            borderRadius: 4,
                            border: `1px solid ${rgba(colors.info.main, 0.08)}`,
                            boxShadow: `0 12px 28px ${rgba(colors.dark.main, 0.06)}`,
                        }}
                    >
                        <Avatar
                            alt={selectedCandidate?.candidate?.full_name}
                            sx={{
                                width: 76,
                                height: 76,
                                bgcolor: colors.info.main,
                                color: "white",
                                fontSize: "1.75rem",
                                fontWeight: 700,
                            }}
                        >
                            {selectedCandidate?.candidate?.full_name?.charAt(0) || "C"}
                        </Avatar>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h5" fontWeight="bold" sx={{ wordBreak: "break-word" }}>
                                {selectedCandidate?.candidate?.full_name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ wordBreak: "break-word" }}>
                                {selectedCandidate?.candidate?.email}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {selectedCandidate?.candidate?.mobile}
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            p: 2,
                            bgcolor: "white",
                            borderRadius: 4,
                            border: `1px solid ${rgba(colors.info.main, 0.08)}`,
                            boxShadow: `0 10px 24px ${rgba(colors.dark.main, 0.05)}`,
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption" sx={{ color: colors.secondary.main, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                    Experience
                                </Typography>
                                <Typography variant="body1" fontWeight={700}>
                                    {selectedCandidate?.candidate?.experience} years
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption" sx={{ color: colors.secondary.main, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                    Status
                                </Typography>
                                <Typography
                                    variant="body1"
                                    fontWeight={700}
                                    sx={{
                                        color: selectedCandidate?.candidate?.status === 4 ? colors.success.main : colors.error.main,
                                    }}
                                >
                                    {selectedCandidate?.candidate?.status_choices[selectedCandidate?.candidate?.status] || "Unknown"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption" sx={{ color: colors.secondary.main, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                    Source
                                </Typography>
                                <Typography variant="body1" fontWeight={700}>
                                    {selectedCandidate?.candidate?.source_choices[selectedCandidate?.candidate?.source] || "N/A"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={1.5}
                        p={2.25}
                        sx={{
                            bgcolor: "white",
                            borderRadius: 4,
                            border: `1px solid ${rgba(colors.info.main, 0.08)}`,
                            boxShadow: `0 10px 24px ${rgba(colors.dark.main, 0.05)}`,
                        }}
                    >
                        <Box display='flex' justifyContent='space-between' alignItems='center'>
                            <Typography variant="h6" fontWeight="bold">
                                Current Stage
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                backgroundColor: colors.background.accent,
                            }}
                        >
                            <Typography variant="body2" mb={0.75}>
                                <b>Flow:</b> {selectedCandidate?.current_flow?.name || "N/A"}
                            </Typography>
                            <Typography variant="body2">
                                <b>Stage:</b> {selectedCandidate?.current_stage?.name || "N/A"}
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={1.5}
                        p={2.25}
                        sx={{
                            bgcolor: "white",
                            borderRadius: 4,
                            border: `1px solid ${rgba(colors.info.main, 0.08)}`,
                            boxShadow: `0 10px 24px ${rgba(colors.dark.main, 0.05)}`,
                        }}
                    >
                        <Box
                            display='flex'
                            justifyContent='space-between'
                            alignItems={{ xs: "flex-start", sm: "center" }}
                            flexDirection={{ xs: "column", sm: "row" }}
                            gap={2}
                        >
                            <Box sx={{ minWidth: 0, width: "100%" }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ color: "#333" }}>
                                    {isSelectedStage
                                        ? 'Selected'
                                        : nextStageTypeLabel === 'New'
                                          ? 'Start Process'
                                          : nextStageTypeLabel === 'Interview'
                                            ? 'Schedule Interview'
                                            : nextStageTypeLabel=== 'Screening'
                                              ? 'Schedule Screening'
                                              : nextStageTypeLabel === 'Selected'
                                                ? 'Selected'
                                                : nextStageTypeLabel === 'Job Offered'
                                                  ? 'Job Offered'
                                                  : 'Onboarded'}
                                </Typography>
                                {/*<Typography variant="body2" color="text.secondary">
                                    Continue the candidate through the hiring workflow from here.
                                </Typography>*/}
                            </Box>
                            {selectedCandidate?.current_flow?.flow_stages && (
                                <Box
                                    mt={1}
                                    display="flex"
                                    gap={1}
                                    flexWrap="wrap"
                                    justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                                    width={{ xs: "100%", sm: "auto" }}
                                >
                                    <MDButton
                                        size='small'
                                        variant="outlined"
                                        color="dark"
                                        sx={{
                                            textTransform: "none",
                                            borderRadius: 3,
                                            px: 2.25,
                                            width: { xs: "100%", sm: "auto" },
                                        }}
                                        onClick={() => {
                                            handleMoveToNextStage(selectedCandidate?.candidate, setCandidates);
                                        }}
                                    >
                                        Move To Next Stage
                                    </MDButton>
                                    <MDButton
                                        size='small'
                                        variant="contained"
                                        color="info"
                                        sx={{
                                            textTransform: "none",
                                            borderRadius: 3,
                                            px: 2.5,
                                            width: { xs: "100%", sm: "auto" },
                                        }}
                                        disabled={isSelectedStage}
                                        onClick={() => {
                                            handleOpenScheduleDialog(selectedCandidate);
                                            setOpenDrawer(false);
                                        }}
                                    >
                                        Schedule
                                    </MDButton>
                                    {isSelectedStage ? (
                                        <MDButton
                                            size='small'
                                            variant="contained"
                                            color="success"
                                            sx={{
                                                textTransform: "none",
                                                borderRadius: 3,
                                                px: 2.5,
                                                width: { xs: "100%", sm: "auto" },
                                            }}
                                            onClick={handleOpenJobOfferDialog}
                                        >
                                            Selected for Job Offer
                                        </MDButton>
                                    ) : null}
                                </Box>
                            )}
                        </Box>

                        {Array.isArray(interviewList?.interviews) && interviewList.interviews.length > 0 ? (
                            <Box display="flex" flexDirection="column" gap={1.5}>
                                {interviewList?.interviews?.map((interview, index) => (
                                    <Box
                                        key={interview.id}
                                        sx={{
                                            p: 2,
                                            borderRadius: 3,
                                            backgroundColor: colors.background.accent,
                                            border: `1px solid ${rgba(colors.info.main, 0.08)}`,
                                        }}
                                    >
                                        <MDBox
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems={{ xs: "flex-start", sm: "center" }}
                                            gap={1.5}
                                            flexDirection={{ xs: "column", sm: "row" }}
                                        >
                                            <Box>
                                                <Typography variant="body1" fontSize="15px" fontWeight="700">
                                                    Interview {index + 1}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Track the round result and recruiter notes.
                                                </Typography>
                                            </Box>
                                            <Box
                                                display="flex"
                                                gap={1}
                                                flexWrap="wrap"
                                                justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                                                width={{ xs: "100%", sm: "auto" }}
                                            >
                                                <MDButton
                                                    variant='outlined'
                                                    color='dark'
                                                    size='small'
                                                    sx={{ borderRadius: 3 }}
                                                    onClick={() => handleToggleFeedback(interview.id)}
                                                >
                                                    Feedback
                                                </MDButton>
                                                {isSelectedStage && index === interviewList?.interviews?.length - 1 ? (
                                                    <MDButton
                                                        variant='contained'
                                                        color='success'
                                                        size='small'
                                                        sx={{ borderRadius: 3 }}
                                                        onClick={handleOpenJobOfferDialog}
                                                    >
                                                        Selected for Job Offer
                                                    </MDButton>
                                                ) : null}
                                            </Box>
                                        </MDBox>
                                        <Grid container spacing={2} sx={{ marginTop: "4px" }}>
                                            <Grid item xs={12} sm={4}>
                                                <Typography variant="body2" fontSize="12px" color="gray">
                                                    Status
                                                </Typography>
                                                <Typography variant="body1" fontSize="14px" fontWeight={600}>{interview?.status}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Typography variant="body2" fontSize="12px" color="gray">
                                                    ID
                                                </Typography>
                                                <Typography variant="body1" fontSize="14px" fontWeight={600}>{interview?.id}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Typography variant="body2" fontSize="12px" color="gray">
                                                    Date
                                                </Typography>
                                                <Typography variant="body1" fontSize="14px" fontWeight={600}>
                                                    {moment(interview?.dateTime).format("YYYY-MM-DD")}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        {expandedInterview === interview.id && (
                                            <Box display="flex" flexDirection="column" gap={2} mt={2}>
                                                <Divider />
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box>
                                                            <Typography variant="body1" fontSize='14px' fontWeight='600px'>Interviewer</Typography>
                                                            <Typography variant="body2" fontSize='12px'>{interviewFeedback?.interviewer || "Not available"}</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box>
                                                            <Typography variant="body1" fontSize='14px' fontWeight='600px'>Ratings</Typography>
                                                            {interviewFeedback?.rating ? (
                                                                <Rating
                                                                    name="custom-star-rating"
                                                                    value={interviewFeedback.rating}
                                                                    readOnly
                                                                    icon={<StarIcon fontSize="small" style={{ color: "yellow" }} />}
                                                                    emptyIcon={<StarBorderIcon fontSize="small" style={{ color: "black" }} />}
                                                                />
                                                            ) : (
                                                                <Typography variant="body2" fontSize='12px'>No Rating</Typography>
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Box>
                                                            <Typography variant="body1" fontSize='14px' fontWeight='600'>Feedback</Typography>
                                                            <Typography variant="body2" fontSize='12px' display='flex' whiteSpace='pre-wrap'>
                                                                {interviewFeedback?.feedback ? interviewFeedback?.feedback : "No Feedback"}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        ) : (
                            <Box
                                display="flex"
                                flexDirection="column"
                                gap={1}
                                p={2}
                                sx={{
                                    borderRadius: 3,
                                    backgroundColor: colors.background.accent,
                                }}
                            >
                                <Typography variant="body2" fontSize='14px' fontWeight={600} textAlign="center">
                                    No scheduled interview yet
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            )}
            </Box>
                                {/*id="recruiter"
                                options={employeeOptions}
                                getOptionLabel={(option) => option.label}
                                value={employeeOptions.find((opt) => opt.value === formData.interviewer) || null}
                                onChange={handleAutocompleteChange("interviewer")}
                                fullWidth

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        name="interviewer"
                                        label="Interviewer"
                                    // variant="standard"

                                    />
                                )}
                            />
                        </Box>*/}
                    {/*</Box> */}

                    {/* View CV */}
                    {/* {selectedCandidate.candidate.cv && (
                                <Box textAlign="center" mt={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        sx={{ textTransform: "none" }}
                                        onClick={() => window.open(selectedCandidate.candidate.cv, "_blank")}
                                    >
                                        View CV
                                    </Button>
                                </Box>
                            )} */}
                {/*</Box>*/}
            {/*)}*/}
        </Drawer>
        <Dialog
            open={jobOfferDialogOpen}
            onClose={handleCloseJobOfferDialog}
            PaperProps={{
                sx: {
                    width: 640,
                    maxWidth: "94vw",
                    borderRadius: "24px",
                }
            }}
        >
            <DialogTitle
                sx={{
                    pb: 1,
                    background: `linear-gradient(135deg, ${colors.success.main} 0%, ${colors.info.main} 100%)`,
                    color: "white",
                }}
            >
                <Typography variant="h5" fontWeight="bold" color="white">
                    Selected for Job Offer
                </Typography>
                <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.86)", mt: 0.5 }}>
                    Create the job offer record first. Template selection and offer-letter delivery happen in the send-offer step.
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
                <Box display="flex" flexDirection="column" gap={2.25} pt={1}>
                    <Box
                        sx={{
                            p: 2,
                            borderRadius: "18px",
                            border: `1px solid ${rgba(colors.info.main, 0.12)}`,
                            backgroundColor: colors.background.accent,
                        }}
                    >
                        <Typography fontWeight={700} mb={1.5}>
                            Candidate Snapshot
                        </Typography>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Candidate</Typography>
                                <Typography fontWeight={600}>{selectedCandidate?.candidate?.full_name || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Email</Typography>
                                <Typography fontWeight={600}>{selectedCandidate?.candidate?.email || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Current Flow</Typography>
                                <Typography fontWeight={600}>{selectedCandidate?.current_flow?.name || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary">Current Stage</Typography>
                                <Typography fontWeight={600}>{selectedCandidate?.current_stage?.name || "N/A"}</Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        sx={{
                            p: 2,
                            borderRadius: "18px",
                            border: `1px solid ${rgba(colors.success.main, 0.12)}`,
                            backgroundColor: "white",
                        }}
                    >
                        <Typography fontWeight={700} mb={1.5}>
                            Offer Details
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Expected DOJ"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={jobOfferPayload.expected_doj}
                                    onChange={(event) =>
                                        setJobOfferPayload((state) => ({
                                            ...state,
                                            expected_doj: event.target.value,
                                        }))
                                    }
                                    helperText="Required for job offer creation."
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="CTC"
                                    type="number"
                                    value={jobOfferPayload.ctc}
                                    onChange={(event) =>
                                        setJobOfferPayload((state) => ({
                                            ...state,
                                            ctc: event.target.value,
                                        }))
                                    }
                                    helperText="Required. Final offer amount."
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={jobOfferPayload.active}
                                            onChange={(event) =>
                                                setJobOfferPayload((state) => ({
                                                    ...state,
                                                    active: event.target.checked,
                                                }))
                                            }
                                        />
                                    }
                                    label="Keep this offer active after creation"
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        sx={{
                            p: 2,
                            borderRadius: "18px",
                            border: `1px dashed ${rgba(colors.warning.main, 0.35)}`,
                            backgroundColor: rgba(colors.warning.main, 0.06),
                        }}
                    >
                        <Typography fontWeight={700} mb={1}>
                            Send-Step Fields
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            The create-offer API only needs <b>Expected DOJ</b>, <b>CTC</b>, candidate, job opening, and active state.
                            Template selection for the offer letter and email is handled in the <b>Send Offer</b> popup after the record is created.
                        </Typography>
                    </Box>

                    {jobOfferError ? (
                        <Typography variant="body2" color="error">
                            {jobOfferError}
                        </Typography>
                    ) : null}
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <MDButton variant="outlined" color="dark" onClick={handleCloseJobOfferDialog}>
                    Close
                </MDButton>
                <MDButton variant="contained" color="success" onClick={handleCreateJobOffer}>
                    Create Job Offer
                </MDButton>
            </DialogActions>
        </Dialog>
        </>
    )
}

export const RenderCandidatesList = ({ filteredItems, filteredCandidatesData, anchorEl, openAction, handleCloseAction, isSmallScreen, state, toggleDrawer, selectedCandidateItem, detailCandidate,
    handleOpenScheduleDialog, handleOpenDrawer, handleActionClick, selectedCandidate, selectedCandidateEmail, handleEmailIconClick, setSelectedItem }) => {

    const status_choices = {
        2: "In Process",  // warning
        3: "Interview started",  // orange
        4: "Selected", // sucess--green
        5: "Joined", // current code
        7: "Reject in interview", // error
        8: "Rejected Offer", // black
        10: "Ready To join",// primary
        13: "High CTC and Notice" // blue
    };
    const getStatusLabel = (status) => status_choices[status] || "Unknown Status";
    const getStatusStyle = (status) => {
        switch (status) {
            case 2:
                return { backgroundColor: "#FFFF00", color: "black" };
            case 3:
                return { backgroundColor: "#FFA500", color: "balck" };
            case 4:
                return { backgroundColor: "#006400", color: "#fff" };
            case 5:
                return { backgroundColor: "#008000", color: "#fff" };
            case 7:
                return { backgroundColor: "#FF0000", color: "#fff" };
            case 8:
                return { backgroundColor: "#000000", color: "#fff" };
            case 10:
                return { backgroundColor: "#E91E63", color: "#fff" };
            case 13:
                return { backgroundColor: "#0000FF", color: "#fff" };
            default:
                return { backgroundColor: "#D3D3D3", color: "black" };
        }
    };
    return (
        <>
            {filteredCandidatesData?.length > 0 ? filteredCandidatesData?.map((item, index) => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '96%', flexWrap: 'wrap', margin : "5px 15px" }} key={item.id || index}>
                    <Card sx={{width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" } }}>
                        <Box>
                            <CardContent sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between", alignItems: { xs: "center", md: "center" }, gap: 2 }}>
                                {/*<Box sx={{ display: "flex", justifyContent: "center" }}>
                                    <Avatar alt="Profile Picture" sx={{ width: 70, height: 70 }} />
                                </Box>*/}
                                <Box
                                    onClick={() => handleOpenDrawer(item)}
                                    sx={{ pt: 1, width: { xs: "100%", md: "20%" }, textAlign: { xs: "center", md: "left" }, cursor: 'pointer' }}>
                                    <Typography sx={{ fontSize: "16px" }}>{item.candidate.full_name}</Typography>
                                    <Typography sx={{ fontSize: "14px" }}>{item.candidate.email}</Typography>
                                </Box>
                                <Box sx={{ pt: 1, width: { xs: "100%", md: "10%" }, textAlign: { xs: "center", md: "left" } }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>Experience</Typography>
                                    <Typography sx={{ fontSize: "14px" }}>{item.candidate.experience} years</Typography>
                                </Box>
                                <Box sx={{ pt: 1, width: { xs: "100%", md: "10%" }, textAlign: { xs: "center", md: "left" } }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>Mobile</Typography>
                                    <Typography sx={{ fontSize: "14px" }}>{item.candidate.mobile}</Typography>
                                </Box>
                                <Box sx={{
                                    pt: 1,
                                    textAlign: { xs: "center", md: "left" },
                                    // backgroundColor: "#DAE8BC",
                                    padding: "2px 5px",
                                    borderRadius: "4px",
                                    width: "150px",
                                    ...getStatusStyle(item.candidate.status)
                                }}>
                                    <Typography sx={{ fontSize: "14px", padding: "2px 5px", borderRadius: "4px", textAlign: "center" }}>{getStatusLabel(item.candidate.status)}</Typography>
                                </Box>
                            </CardContent>
                        </Box>
                    </Card>
                </Box>
            )) : 
					<Grid item xs={12}>
						<Card
							sx={{
								m: 3,
								p: 5,
								borderRadius: "24px",
								textAlign: "center",
								border: `1px dashed ${colors.secondary.main}40`,
								pt: 7,
								background : `linear-gradient(335deg, ${colors.light.main} 0%, ${colors.info.main} 150%)`
							}}
						>
							<MDTypography variant="h5" sx={{ mb: 1 }}>
								Candidates haven't reached this stage
							</MDTypography>
							<MDTypography variant="body2" color="text">
								Please add or move candites for them to visible here.
							</MDTypography>
						</Card>
					</Grid>
						}



        </>
    )
}
